var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiteinanderWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:1.5px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-1,.cls-5,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-1,.cls-3{stroke:#010101;}.cls-6,.cls-7{fill:#010101;}.cls-8,.cls-5{fill:#020202;}.cls-9{fill:#fff;}.cls-10{fill:#fff1d7;}.cls-11{fill:#f38294;}.cls-12{fill:#fbc5bd;}.cls-2,.cls-5,.cls-4,.cls-7{stroke-width:2px;}.cls-2,.cls-7{stroke:#020202;}.cls-5,.cls-4{stroke:#030303;}.cls-3{stroke-width:1.45px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.39,
    y: 0.2,
    width: 124.79,
    height: 92.91,
    transform: "translate(.15 -.26) rotate(.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 25.4,
    y: 29.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 26.4,
    y: 30.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 20.4,
    y: 24.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.4,
    y: 25.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M67.55,49.45l-12.26-11.43c-.37-.34-.7-.71-.99-1.12-3.06-4.3-2.41-10.19,1.28-13.46,3.43-3.04,8.84-3.25,12.82-.31,4.43-2.6,9.61-2.67,12.82,.01,3.62,3.02,4.57,8.34,2.27,12.57-.29,.54-.66,1.03-1.08,1.47-3.79,4.05-7.58,8.09-11.36,12.14-.93,.99-2.49,1.04-3.49,.11h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.55,49.45l-12.26-11.43c-.37-.34-.7-.71-.99-1.12-3.06-4.3-2.41-10.19,1.28-13.46,3.43-3.04,8.84-3.25,12.82-.31,4.43-2.6,9.61-2.67,12.82,.01,3.62,3.02,4.57,8.34,2.27,12.57-.29,.54-.66,1.03-1.08,1.47-3.79,4.05-7.58,8.09-11.36,12.14-.93,.99-2.49,1.04-3.49,.11h0v.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.11,45.63l-12.26-11.43c-.37-.34-.7-.71-.99-1.12-3.06-4.3-2.41-10.19,1.28-13.46,3.43-3.04,8.84-3.25,12.82-.31,4.43-2.6,9.61-2.67,12.82,0,3.62,3.02,4.57,8.34,2.27,12.57-.29,.54-.66,1.03-1.08,1.47-3.79,4.05-7.58,8.09-11.36,12.14-.93,.99-2.49,1.04-3.49,.11h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.11,45.63l-12.26-11.43c-.37-.34-.7-.71-.99-1.12-3.06-4.3-2.41-10.19,1.28-13.46,3.43-3.04,8.84-3.25,12.82-.31,4.43-2.6,9.61-2.67,12.82,0,3.62,3.02,4.57,8.34,2.27,12.57-.29,.54-.66,1.03-1.08,1.47-3.79,4.05-7.58,8.09-11.36,12.14-.93,.99-2.49,1.04-3.49,.11h0v.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M61.5,59.08c1.25,0,1.28,.56,1.28,1.81s-4.15,2.14-5.35,2.2h-11.49c-.52,0-1.31-.22-1.76-.47l-14.54-8.98c-.45-.25-1.24-.46-1.76-.46h-2.75v-9.07h10.51l4.68,2.06,9.31,9.75h11.79l.79,2.15-.72,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.24,54.71h-7.49c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h7.49c.85,0,1.54,.69,1.54,1.54,0,.17-.03,.34-.08,.5-.43-.24-.93-.38-1.45-.38h-10.23c.69-1.15,.54-2.67-.45-3.66l-8.58-8.58c-1.24-1.24-3.58-2.21-5.33-2.21h-10.53c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h10.51c1.37,0,3.34,.82,4.3,1.78l8.58,8.58c.6,.6,.6,1.57,0,2.17-.6,.6-1.57,.6-2.17,0l-6.98-6.98c-.29-.29-.75-.29-1.03,0-.29,.29-.29,.75,0,1.03l6.98,6.98c.57,.57,1.32,.86,2.07,.88h12.85c.85,0,1.54,.69,1.54,1.54s-.69,1.54-1.54,1.54h-14.29c-.39,0-1.05-.18-1.39-.37l-14.53-8.97s-.02,0-.03-.02c-.56-.32-1.47-.55-2.12-.55h-2.75c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h2.75c.39,0,1.05,.17,1.39,.36l14.53,8.97s.02,0,.03,.02c.56,.32,1.47,.55,2.12,.56h14.29c1.65,0,3-1.33,3-2.98,0-.57-.16-1.1-.44-1.56,.28-.47,.44-1,.44-1.56,0-1.65-1.34-3-3-3h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.17,
    y1: 44.1,
    x2: 25.17,
    y2: 53.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.02,
    y1: 55.44,
    x2: 49.36,
    y2: 55.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.58,63.61l.79-2.15h11.79l9.31-9.75,4.68-2.06h10.51v9.07h-2.75c-.52,0-1.31,.21-1.76,.46l-14.54,8.98c-.45,.25-1.24,.46-1.76,.46h-11.49c-1.2-.06-5.35-.98-5.35-2.2s.03-1.81,1.28-1.81l-.72-1.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.57,63.24c0,.56,.15,1.09,.44,1.56-.28,.45-.44,.99-.44,1.56,0,1.65,1.34,3,3,3h14.29c.65,0,1.56-.25,2.12-.57,0,0,.02,0,.03-.02l14.53-8.97c.35-.19,1-.36,1.39-.36h2.75c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-2.75c-.65,0-1.56,.24-2.12,.55,0,0-.02,0-.03,.02l-14.53,8.97c-.35,.19-1,.36-1.39,.36h-14.29c-.85,0-1.54-.68-1.54-1.52s.69-1.54,1.54-1.54h12.85c.75,0,1.5-.3,2.07-.88l6.98-6.98c.29-.29,.29-.75,0-1.03-.29-.29-.75-.29-1.03,0l-6.98,6.98c-.6,.6-1.57,.6-2.17,0s-.6-1.57,0-2.17l8.58-8.58c.97-.97,2.94-1.78,4.3-1.78h10.51c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-10.51c-1.75,0-4.09,.97-5.33,2.21l-8.58,8.58c-.99,.99-1.14,2.51-.45,3.66h-10.23c-.53,0-1.02,.14-1.45,.38-.05-.16-.08-.32-.08-.5,0-.85,.69-1.54,1.54-1.54h7.49c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-7.49c-1.65,0-3,1.34-3,3h-.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 118.63,
    y1: 49.64,
    x2: 118.63,
    y2: 58.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 90.78,
    y1: 60.97,
    x2: 94.44,
    y2: 60.97
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 21.4,
    y: 43.37,
    width: 4.46,
    height: 10.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M58.5,56.08c1.25,0,1.28,.56,1.28,1.81s-4.15,2.14-5.35,2.2h-11.49c-.52,0-1.31-.22-1.76-.47l-14.54-8.98c-.45-.25-1.24-.46-1.76-.46h-2.75v-9.07h10.51l4.68,2.06,9.31,9.75h11.79l.79,2.15-.72,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M57.24,51.71h-7.49c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h7.49c.85,0,1.54,.69,1.54,1.54,0,.17-.03,.34-.08,.5-.43-.24-.93-.38-1.45-.38h-10.23c.69-1.15,.54-2.67-.45-3.66l-8.58-8.58c-1.24-1.24-3.58-2.21-5.33-2.21h-10.53c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h10.51c1.37,0,3.34,.82,4.3,1.78l8.58,8.58c.6,.6,.6,1.57,0,2.17-.6,.6-1.57,.6-2.17,0l-6.98-6.98c-.29-.29-.75-.29-1.03,0-.29,.29-.29,.75,0,1.03l6.98,6.98c.57,.57,1.32,.86,2.07,.88h12.85c.85,0,1.54,.69,1.54,1.54s-.69,1.54-1.54,1.54h-14.29c-.39,0-1.05-.18-1.39-.37l-14.53-8.97s-.02,0-.03-.02c-.56-.32-1.47-.55-2.12-.55h-2.75c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h2.75c.39,0,1.05,.17,1.39,.36l14.53,8.97s.02,0,.03,.02c.56,.32,1.47,.55,2.12,.56h14.29c1.65,0,3-1.33,3-2.98,0-.57-.16-1.1-.44-1.56,.28-.47,.44-1,.44-1.56,0-1.65-1.34-3-3-3h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.17,
    y1: 41.1,
    x2: 22.17,
    y2: 50.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.02,
    y1: 52.44,
    x2: 46.36,
    y2: 52.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.58,60.61l.79-2.15h11.79l9.31-9.75,4.68-2.06h10.51v9.07h-2.75c-.52,0-1.31,.21-1.76,.46l-14.54,8.98c-.45,.25-1.24,.46-1.76,.46h-11.49c-1.2-.06-5.35-.98-5.35-2.2s.03-1.81,1.28-1.81l-.72-1.01h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M77.57,60.24c0,.56,.15,1.09,.44,1.56-.28,.45-.44,.99-.44,1.56,0,1.65,1.34,3,3,3h14.29c.65,0,1.56-.25,2.12-.57,0,0,.02,0,.03-.02l14.53-8.97c.35-.19,1-.36,1.39-.36h2.75c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-2.75c-.65,0-1.56,.24-2.12,.55,0,0-.02,0-.03,.02l-14.53,8.97c-.35,.19-1,.36-1.39,.36h-14.29c-.85,0-1.54-.68-1.54-1.52s.69-1.54,1.54-1.54h12.85c.75,0,1.5-.3,2.07-.88l6.98-6.98c.29-.29,.29-.75,0-1.03-.29-.29-.75-.29-1.03,0l-6.98,6.98c-.6,.6-1.57,.6-2.17,0s-.6-1.57,0-2.17l8.58-8.58c.97-.97,2.94-1.78,4.3-1.78h10.51c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-10.51c-1.75,0-4.09,.97-5.33,2.21l-8.58,8.58c-.99,.99-1.14,2.51-.45,3.66h-10.23c-.53,0-1.02,.14-1.45,.38-.05-.16-.08-.32-.08-.5,0-.85,.69-1.54,1.54-1.54h7.49c.4,0,.73-.33,.73-.73s-.33-.73-.73-.73h-7.49c-1.65,0-3,1.34-3,3h-.02Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 115.63,
    y1: 46.64,
    x2: 115.63,
    y2: 55.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 87.78,
    y1: 57.97,
    x2: 91.44,
    y2: 57.97
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiteinanderWeb);
export default __webpack_public_path__ + "static/media/miteinander_web.f441ba92c6c74530a801717db44db528.svg";
export { ForwardRef as ReactComponent };